import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class ShipmentService {
    async lookupCities(params) {
        try {
            const response = await axios.get(`${config["apiUrl"]}nacex/cities`, {
                params,
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return null;
        }
    }

    async createShipment(data) {
        try {
            const response = await axios.post(`${config["apiUrl"]}nacex/shipment`, data, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    async createInternalDossierShipment(data) {
        try {
            const response = await axios.post(`${config["apiUrl"]}nacex/internal-dossier/shipment`, data, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    async schedulePickup(data) {
        try {
            const response = await axios.post(`${config["apiUrl"]}nacex/pickup`, data, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    async scheduleInternalDossierPickup(data) {
        try {
            const response = await axios.post(`${config["apiUrl"]}nacex/internal-dossier/pickup`, data, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    async createShipmentWithReturn(data) {
        try {
            const response = await axios.post(`${config["apiUrl"]}nacex/return`, data, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    async createInternalDossierReturn(data) {
        try {
            const response = await axios.post(`${config["apiUrl"]}nacex/internal-dossier/return`, data, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    async getAllShipments(params) {
        try {
            const response = await axios.get(`${config["apiUrl"]}nacex/shipments`, {
                params: params,
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return null;
        }
    }

    async getShipmentsByPat(patId, params) {
        try {
            const response = await axios.get(`${config["apiUrl"]}nacex/pat/${patId}/shipments`, {
                params: params,
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return null;
        }
    }

    async updateShipment(id, data) {
        try {
            const response = await axios.post(`${config["apiUrl"]}nacex/shipment/${id}/edit`, data, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return null;
        }
    }

    async syncShipmentStatus(id) {
        try {
            const response = await axios.get(`${config["apiUrl"]}nacex/shipment/${id}/sync`, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return null;
        }
    }

    async cancelShipment(id) {
        try {
            const response = await axios.post(`${config["apiUrl"]}nacex/shipment/${id}/cancel`, {}, {
                headers: authHeader(),
            });
            return response.status === 200 ? response.data : null;
        } catch (error) {
            this.handleError(error);
            return error.response?.data || null;
        }
    }

    async getShipmentById(id) {
        try {
            const response = await axios.get(`${config["apiUrl"]}nacex/shipment/${id}`, {
                headers: authHeader(),
            });
            return response.status === 200 ? response : null;
        } catch (error) {
            this.handleError(error);
            return null;
        }
    }

    async createManualShipment(data) {
        try {
            const response = await axios.post(
                `${config["apiUrl"]}internal-dossier/manual-shipment`,
                data,
                { headers: authHeader() }
            );
            return response.data;
        } catch (error) {
            this.handleError(error);
            throw error;
        }
    }

    handleError(error) {
        if (error.response?.status === 401) {
            AuthService.logout();
            window.location = "/login";
        }
        console.log("ERROR:: ", error.response?.data);
    }
}
export default new ShipmentService();
